import { languages as interfaceLanguages } from 'src/i18n/languages.js'

// Languages a post can be marked with: the interface languages and other
// widely used ones, as plain ISO 639 codes.

const MORE = [
  'bn',
  'da',
  'el',
  'fa',
  'hi',
  'id',
  'ms',
  'pa',
  'sv',
  'sw',
  'th',
  'tr',
  'uk',
  'ur',
  'vi',
  'zh',
]

// 'ja_easy' → 'ja', 'zh-Hant' → 'zh'
export const baseLanguage = (code) =>
  code ? code.split(/[-_]/)[0].toLowerCase() : null

// the list, with the given language added when it is not in it
export const postLanguages = (locale, current) => {
  const names = new Intl.DisplayNames([locale, 'en'], { type: 'language' })
  const codes = [
    ...new Set([
      ...interfaceLanguages.map(baseLanguage),
      ...MORE,
      baseLanguage(current),
    ]),
  ].filter(Boolean)
  return codes
    .map((code) => ({ code, name: names.of(code) }))
    .sort((a, b) => a.name.localeCompare(b.name, locale))
}

// the interface language as a plain code; the setting is a list, or a
// single code in older settings
export const interfaceBaseLanguage = (interfaceLanguage, fallback) =>
  baseLanguage([].concat(interfaceLanguage ?? [])[0] ?? fallback)
